import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  companyNameValidator,
  emailValidatorRequired,
  nameSurnameValidatorRequired,
  phoneValidatorRequired,
  radioValidator,
} from "../../../../../utilities/validators";
import { trimmedString } from "../../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.OWNER_CONTACT_PERSON_DATA]: yup.object({
    [ComponentId.TYPE]: radioValidator,
    [ComponentId.NAME]: trimmedString.onlyIfFieldIsVisible(
      nameSurnameValidatorRequired
    ),
    [ComponentId.SURNAME]: trimmedString.onlyIfFieldIsVisible(
      nameSurnameValidatorRequired
    ),
    [ComponentId.COMPANY_NAME]:
      trimmedString.onlyIfFieldIsVisible(companyNameValidator),
    [ComponentId.PHONE]: phoneValidatorRequired("contactPersonphone"),
    [ComponentId.EMAIL]: trimmedString.onlyIfFieldIsVisible(
      emailValidatorRequired
    ),
  }),
};
